import { validateRequiredFields } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredFields';
import { validateRecaptchaVerified } from '@framework/ui/Organisms/FinalForm/validators/validateRecaptchaVerified';
import { validateCompanyName } from '@framework/ui/Organisms/FinalForm/validators/company/validateCompanyName';
import { validateName } from '@framework/ui/Organisms/FinalForm/validators/user/validateName';
import { validateEmail } from '@framework/ui/Organisms/FinalForm/validators/user/validateEmail';
import { validatePhoneNumber } from '@framework/ui/Organisms/FinalForm/validators/user/validatePhoneNumber';
import {
  groupValidators,
} from '@framework/ui/Organisms/FinalForm/validators/helpers';

export default (values: {
  period?: string,
  size?: string,
  currency?: string,
  company?: string,
  firstName?: string,
  lastName?: string,
  email?: string,
  recaptcha?: string,
  phone?: { value: string, code: string },
}) => groupValidators(
  validateRequiredFields([
    { fieldName: 'period' },
    { fieldName: 'size' },
    { fieldName: 'currency' },
    { fieldName: 'company', fieldCaption: 'Company' },
    { fieldName: 'firstName', fieldCaption: 'First Name' },
    { fieldName: 'lastName', fieldCaption: 'Last Name' },
    { fieldName: 'email', fieldCaption: 'Corporate Email' },
  ], values),
  validateRecaptchaVerified({ fieldName: 'recaptcha', value: values.recaptcha }),
  validateCompanyName({ fieldName: 'company', fieldCaption: 'Company', value: values.company }),
  validateName({ fieldName: 'firstName', fieldCaption: 'First Name', value: values.firstName }),
  validateName({ fieldName: 'lastName', fieldCaption: 'Last Name', value: values.lastName }),
  validateEmail({ fieldName: 'email', value: values.email }),
  validatePhoneNumber({
    fieldName: 'phone',
    fieldCaption: 'Phone Number',
    value: values.phone,
    isRequired: true,
  }),
);
